import download from "./download";
import axios from 'axios';

async function downloadMarketingPersonsExcel(filters: {
  marketingPersonId?: number;
  startPeriod?: string;
  endPeriod?: string;
}) {
  const token = localStorage.getItem('token');
  try {
    const url = `${process.env.REACT_APP_API_URL}/admin/marketing-persons/report/excel`;
    const response = await axios({
      url,
      method: "POST",
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
      data: filters,
    });
    download(
      response.data,
      `Marketing-Persons-Report`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  } catch (error) {
    console.error("Failed to download marketing persons excel", error);
  }
}

async function downloadSingleMarketingPersonExcel(
  personId: number,
  filters: { startPeriod?: string; endPeriod?: string }
) {
  const token = localStorage.getItem('token');
  try {
    const params = new URLSearchParams();
    if (filters.startPeriod) params.append('startPeriod', filters.startPeriod);
    if (filters.endPeriod) params.append('endPeriod', filters.endPeriod);

    const url = `${process.env.REACT_APP_API_URL}/admin/marketing-persons/${personId}/report/excel?${params.toString()}`;
    const response = await axios({
      url,
      method: "GET",
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
    });
    download(
      response.data,
      `Marketing-Person-${personId}-Report`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  } catch (error) {
    console.error("Failed to download single marketing person excel", error);
  }
}

async function downloadMarketingPaymentsExcel(filters: {
  marketingPersonId?: number;
  organizerId?: number;
  eventId?: number;
  kind?: 'event' | 'organizer' | 'referral';
  monthFrom?: string;
  monthTo?: string;
  search?: string;
}) {
  const token = localStorage.getItem('token');
  try {
    const url = `${process.env.REACT_APP_API_URL}/admin/marketing-persons/payments/excel`;
    const response = await axios({
      url,
      method: 'POST',
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
      data: filters,
    });
    download(
      response.data,
      `Marketing-Payments-Report`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  } catch (error) {
    console.error('Failed to download payments excel', error);
  }
}

async function downloadPayoutExcel(payoutId: number) {
  const token = localStorage.getItem('token');
  try {
    const url = `${process.env.REACT_APP_API_URL}/admin/marketing-persons/payouts/${payoutId}/excel`;
    const response = await axios({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
    });
    download(
      response.data,
      `Payout-${payoutId}`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  } catch (error) {
    console.error('Failed to download payout excel', error);
  }
}

export { downloadMarketingPersonsExcel, downloadSingleMarketingPersonExcel, downloadMarketingPaymentsExcel, downloadPayoutExcel };
